const { cELM, getQuestionAnswerTestId } = require("../../utils");
const Chat = require("../../chat");

class ButtonClick {
  constructor(data, callback, matchingAns) {
    this._data = data;
    this.options = data.values.split("|");
    this.matchingAns = matchingAns;
    this.element = cELM("div", "option-block");
    this.callback = callback;
  }

  getELM() {
    return this.element;
  }

  getHTML() {
    const _self = this;

    this.options.forEach((op, idx) => {
      op = op.trim();
      const _el = cELM("div", "button", op);

      const testId = getQuestionAnswerTestId(this._data, op);
      testId && _el.setAttribute('data-testid', testId);

      _el.onclick = function(evt) {
        if (window.__FN_DATA_WRAPPER) {
          let data = window.__FN_DATA_WRAPPER(op);

          data = (typeof data == 'string')
            ? { text: data, id: _self._data.id }
            : { ...data, id: _self._data.id };

          Chat.default.send(data, null, _self.element);
        } else {
          if (_self.matchingAns) {
            Chat.default.send({text:_self.matchingAns[idx],id:_self._data.id}, null, _self.element);
          } else {
            Chat.default.send({text:op,id:_self._data.id}, null, _self.element);
          }
        }

        if (_self.callback) {
          _self.callback(op);
        }
      };

      this.element.addELM(_el);
    });

    return this.element;
  }

  reset() {}
  focus() {}
}

module.exports = ButtonClick;
